import Alpine from 'alpinejs';

import { PlaylistModal } from './playlist_modal';

Alpine.data('playlistModal', (videoId: string) => new PlaylistModal(videoId));
